import { render, staticRenderFns } from "./UserTravelerData.vue?vue&type=template&id=b7b88394&"
import script from "./UserTravelerData.vue?vue&type=script&lang=js&"
export * from "./UserTravelerData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports